import { createCachedSelector } from 're-reselect';
import { useSelector } from 'react-redux';
import { IGlobalReduxStore } from 'store';
import { isUserObjectB2bType } from 'types/common.types';

const getUser = (state: IGlobalReduxStore) => state.auth.user;

const isB2bSecondaryReadOnly = (user: { user_type?: string; read_only?: boolean }): boolean => {
  return user.user_type === 'SecondaryUser' && user.read_only !== false;
};

export const isUserReadOnlySelector = createCachedSelector([getUser], (user) => {
  if (!user || !isUserObjectB2bType(user)) {
    return false;
  }

  return isB2bSecondaryReadOnly(user);
})((store) => {
  const user = store.auth.user;

  if (!user) return 'NO_SESSION';
  if (!isUserObjectB2bType(user)) return 'AGENCY_USER';

  return isB2bSecondaryReadOnly(user) ? 'READ_ONLY' : 'NOT_READ_ONLY';
});

export const useIsUserReadOnlySelector = () => useSelector(isUserReadOnlySelector);
